import cn from "classnames";
import styles from "./loader.module.scss";

type Props = {
  className?: string;
};

const Loader = ({ className }: Props) => (
  <div className={cn(styles.loader, className)} />
);

export { Loader };
